// extracted by mini-css-extract-plugin
export var animationContainer = "_nb-0";
export var footer = "_nb-1";
export var gray = "_nb-2";
export var lineItem = "_nb-3";
export var lineItemImage = "_nb-4";
export var lineItemInfo = "_nb-5";
export var lineItemText = "_nb-6";
export var lineItems = "_nb-7";
export var modalContent = "_nb-8";
export var options = "_nb-9";
export var orderName = "_nb-a";
export var refundAmount = "_nb-b";